<div class="card table-settings-header">
  <div class="card-header pointer p-3"
       (click)="toggleIsOpen()">
    <div class="layout-row layout-align-start-center">
      <span class="flex-grow-1 br-body-2 gray-100">{{ title || 'Customized Table Columns' | translate }}</span>
      <app-expand-button [isExpanded]="isOpen"
                         (onToggle)="toggleIsOpen()">
      </app-expand-button>
    </div>
  </div>

  <div *ngIf="isOpen" class="card-body fade-element-in">
    <div class="layout-wrap columns-container">
      <div *ngFor="let column of columns" class="col-6">
        <bringoz-switch
          *ngxPermissionsOnly="column.permission"
          [checked]="column.enabled"
          [name]="column.title"
          [label]="column.title"
          (onChange)="column.enabled = $event; columnsChanged()">
        </bringoz-switch>
      </div>
    </div>
  </div>
</div>
